import { AnchorButton, Intent } from '@blueprintjs/core';
import * as React from 'react';
import { copyToClipboard, getIsClipboardEnabled } from 'vet-bones/utils';

import * as copy from 'src/templates/copy';

type ErrorNotificationMessageProps = {
  message: string;
  testId: string;
};

export const ErrorNotificationMessage: React.VFC<
  ErrorNotificationMessageProps
> = ({ message, testId }) => {
  const [isCopied, setIsCopied] = React.useState(false);

  return (
    <>
      <div className="sd-toast-actionable-message">
        <span
          className="sd-toast-error-message sd-selectable"
          data-testid={testId}
        >
          {message}
        </span>
      </div>
      {getIsClipboardEnabled() ? (
        <div className="sd-toast-actionable-actions">
          <AnchorButton
            data-testid={`${testId}-copy`}
            intent={Intent.DANGER}
            minimal
            onClick={() => {
              copyToClipboard(message);
              setIsCopied(true);
            }}
            text={
              isCopied
                ? copy.notifications.defaults.copied
                : copy.notifications.defaults.copy
            }
          />
        </div>
      ) : null}
    </>
  );
};
